export type ChoosePinChannel = "whatsapp" | "email" | "phone";

export const CHOOSE_PIN_PATH = "/register/choosepin";
export const CHOOSE_PIN_TITLE = "Valide seus dados";
export const CHOOSE_PIN_VIEW_EVENT = "page_view";
export const CHOOSE_PIN_SELECT_EVENT = "choose_pin_select";

const pushChoosePinEvent = (
  event: string,
  fields: Record<string, unknown> = {},
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    page_path: CHOOSE_PIN_PATH,
    page_title: CHOOSE_PIN_TITLE,
    ...fields,
  });
};

export const choosePinSelectGaEvent = (channel: ChoosePinChannel) =>
  `choose_pin_select_${channel}`;

export const trackChoosePinView = () =>
  pushChoosePinEvent(CHOOSE_PIN_VIEW_EVENT);

export const trackChoosePinSelect = (channel: ChoosePinChannel) =>
  pushChoosePinEvent(CHOOSE_PIN_SELECT_EVENT, { channel });
